<script>
import { computed} from "vue";
import { useStore } from "vuex";
export default {
    setup(){
      
    const store = useStore();
    // 取得列表開關狀態
    const isOpen = computed(() => store.getters.isOpen);
    // 觸發開關
    const handClickMenu = () =>{
      store.dispatch("handMenuOpen")
    }

    return{
       handClickMenu,
       isOpen,
    };
  }
}
</script>

<template>
<header :class="{openMenu: isOpen}">
        <nav>
          <a id="moblie_menu" @click="handClickMenu" href="javascript:;"></a>
          <div>
            <router-link to="/">Intelligent Information Acquisition Laboratory</router-link>
            <router-link to="/unanimous">Purpose of establishment</router-link>
            <router-link to="/professor">Professor</router-link>
            <router-link to="/member">Lab member</router-link>
            <router-link to="/equipment">Laboratory equipment</router-link>
            <router-link to="/research">Research project</router-link>
            <router-link to="/published">Published works</router-link>
          </div>
        </nav>
</header>

</template>


<style lang="scss" scoped>
header {
  background-color: #373c3f;
  width: 100%;
  height: 97px;
  @media screen and (max-width: 640px) {
    transition: height 0.2s;
    height: 37px;
    overflow: hidden;
    &.openMenu{
      height: 232px;
    }
  }
  > nav {
  position: relative;
  width: 1024px;
  height: 100%;
  margin: 0 auto;
  @media screen and (max-width: 1044px) {
    width: 100%;
  }
  @media screen and (max-width: 640px) {
    width: 100%;
    height: 232px;
  }
    > h1 {
    line-height: 97px;
    font-size: 18px;
    float: left;
    color: #fff;
    margin-right: 20px;
    @media screen and (max-width: 1044px) {
       margin-left: 5%;
    }
    @media screen and (max-width: 640px) {
      line-height: 37px;
    }
    }
    div {
    width: 100%;
    height: 100%;
     @media screen and (max-width: 640px) {
       clear: both;
       width: 100%;
       height: 195px;
    }
      > a {
        display: block;
        line-height: 97px;
        font-size: 20px;
        float: left;
        color: #fff;
        padding: 0 10px;
        @media screen and (max-width: 640px) {
          width: 100%;
          height: auto;
          overflow: hidden;
          line-height: 37px;
          text-align: center;
        }
      }
    }
  }
}

a#moblie_menu {
  display: none;
  @media screen and (max-width: 640px) {
      position: absolute;
      top: 0;
      right: 0;
      display: block;
      width: 37px;
      height: 37px;
      background-image: url("~@/assets/img/menu.jpg");
      background-position: 50% 50%;
      background-size: 95% auto;
      background-repeat: no-repeat;
    }
}
</style>